const AboutMetaPixel = () => {
    return (
        <div className="px-1 py-1 text-sm">
            <p className="tw:text-xl tw:font-medium tw:leading-[150%] tw:!mb-2">About the Meta pixel</p>
            <p className="tw:text-sm tw:text-wrap">
                The Meta pixel is a piece of code that you add to your website to track conversions from your ads.
            </p>
            <p className="tw:text-xl tw:font-medium tw:leading-[150%] tw:!mb-2">Can't find a pixel?</p>
            <p className="tw:text-sm tw:text-wrap">
                Only pixels associated with this ad account are shown here. If you can't find a pixel, it may not be
                associated with this account. Go to Meta Business Manager to share the pixel with this account.
            </p>
            <p className="tw:text-xl tw:font-medium tw:!mb-2 tw:leading-[150%]">Useful links</p>
            <ul className="tw:list-disc tw:list-inside tw:text-current tw:!pl-2">
                <li className="tw:font-semibold">
                    <a href="https://business.facebook.com" target="_blank">
                        Meta Business Manager
                    </a>
                </li>
                <li className="tw:font-semibold">
                    <a href="https://www.facebook.com/business/help/910137316041095" target="_blank">
                        How to add ad account?
                    </a>
                </li>
            </ul>
        </div>
    )
}

export default AboutMetaPixel
